<div class="checkbox-input-container" *ngIf="fieldInfo">
  <ng-container *ngFor="let name of fieldInfo.translations">
    <div class="d-flex align-items-center" *ngIf="name.lang === panelLanguage">
      <h5 class="checkboxes-header">{{ name.label | uppercase }}</h5>
      <div class="info-icon" *ngIf="name.help">
        <h4>
          <nb-icon icon="info" pack="icomoon" [ngbTooltip]="name.help" container="body"></nb-icon>
        </h4>
      </div>
    </div>
  </ng-container>
  <label class="filter-element" *ngFor="let value of checkboxValues">
    <input type="checkbox" name="{{ value }}" (change)="getValue($event, value)" />
    <div class="element-text">{{ value }}</div>
    <span class="checkmark">
      <!-- <nb-icon icon="check" pack="icomoon"></nb-icon> -->
    </span>
  </label>
  <div class="error-text" *ngIf="submitted && !checkedValues.length">
    <small class="form-text text-danger">{{ 'view_translations.this_field_is_required' | translate }}</small>
  </div>
</div>
